"use strict";

exports.__esModule = true;
exports.default = SimpleFormat;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var pattern = /([^\n]\n)(?=[^\n])/g;
var keyPrefix = 'paragraph';

function splitParagraphs(text) {
  return text.replace(/\r\n?/g, '\n').split(/\n\n+/).map(function (t) {
    return pattern.test(t) ? t.replace(pattern, '$1<br/>') : t;
  });
}

function SimpleFormat(_ref) {
  var text = _ref.text,
      wrapperTag = _ref.wrapperTag,
      prefix = _ref.prefix,
      postfix = _ref.postfix,
      props = _objectWithoutPropertiesLoose(_ref, ["text", "wrapperTag", "prefix", "postfix"]);

  var sanitizedText = text ? (0, _sanitizeHtml.default)(text) : '';
  var paragraphs = splitParagraphs(sanitizedText);
  var length = paragraphs.length;
  var children = paragraphs.map(function (p, i) {
    var element = (0, _htmlReactParser.default)(p);
    if (!Array.isArray(element)) element = [element];
    if (i === 0 && prefix) element = [prefix].concat(element);
    if (i === length - 1 && postfix) element = [].concat(element, [postfix]);
    return _react.default.createElement(wrapperTag, Object.assign({
      key: keyPrefix + "-" + i
    }, props), element);
  });
  return _react.default.createElement('div', {}, children);
}

SimpleFormat.propTypes = {
  text: _propTypes.default.string,
  wrapperTag: _propTypes.default.string,
  prefix: _propTypes.default.node,
  postfix: _propTypes.default.node
};
SimpleFormat.defaultProps = {
  wrapperTag: 'p'
};